import { ReactComponent as SearchIconSVG } from '@/assets/icons/SearchIcon.svg';
import { SVGProps } from 'react';

const SearchIcon = (props: SVGProps<SVGSVGElement>) => <SearchIconSVG {...props} />;

export default SearchIcon;
